import { Box } from "@mantine/core";
import React from "react";
import DynamicText from "./DynamicText";
import DynamicImage from "./DynamicImage";
import CaptionsList from "./CaptionsList";
import { PlayerType, ThemeType } from "../util/types";
import PlayerReminder from "./PlayerReminder";
import PlayerBadges from "./PlayerBadges";

interface ImageAndCaptionsProps {
  round: string;
  players: PlayerType[];
  instructions: string;
  imageUrl: string;
  captions: string[];
  reminder: string;
  theme: ThemeType;
  judge?: string;
}

const ImageAndCaptions: React.FC<ImageAndCaptionsProps> = ({
  round,
  instructions,
  imageUrl,
  captions,
  reminder,
  players,
  judge,
  theme,
}) => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Box style={{ marginBottom: "10px" }}>
        <DynamicText style={{ fontSize: 15, color: theme.ButtonColor }}>
          {round}
        </DynamicText>
        <DynamicText style={{ fontSize: 35, marginTop: 50 }}>
          {instructions}
        </DynamicText>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          height: "80%",
        }}
      >
        <Box
          id={"MemeContainer"}
          style={{
            width: "50%",
            height: "100%",
            alignContent: "center",
            justifyItems: "center",
          }}
        >
          <DynamicImage src={imageUrl} parentId={"MemeContainer"} />
        </Box>
        <Box style={{ width: "50%", marginLeft: 10 }}>
          <CaptionsList captions={captions} theme={theme} />
        </Box>
      </Box>
      <Box style={{ marginBottom: "20px" }}>
        <PlayerReminder reminder={reminder} theme={theme} />
        {players && (
          <PlayerBadges
            players={players}
            judge={judge}
            theme={theme}
            allowTwoRows={false}
            showScores
          />
        )}
      </Box>
    </Box>
  );
};

export default ImageAndCaptions;
